import LftAvatar from '@lift/design-system-react-web/dist/components/LftAvatar';
import LftSkeleton from '@lift/design-system-react-web/dist/components/LftSkeleton';
import { useCallback } from 'react';
import S from './avatar-usuario.styles';
import { AvatarUsuarioProps } from './avatar-usuario.types';

export const AvatarUsuario: React.FC<AvatarUsuarioProps> = ({ emailUsuario, nomeUsuario, size }) => {
  const Skeleton = useCallback(
    () => (
      <S.AvatarWrapper data-testid="skeleton-avatar-usuario">
        <div>
          <LftSkeleton shape="circle" />
        </div>
      </S.AvatarWrapper>
    ),
    [],
  );

  const nomeValido = nomeUsuario && nomeUsuario.toLowerCase() !== 'unknown' ? nomeUsuario.toUpperCase() : null;
  const description = nomeValido ?? emailUsuario;

  return description ? (
    <S.AvatarWrapper>
      <div>
        <LftAvatar description={description} size={size} />
      </div>
    </S.AvatarWrapper>
  ) : (
    <Skeleton />
  );
};
